module.exports = __webpack_public_path__ + "img/49.5.COD.0f7eb01b.png";